<template>
  <div id="dashboard-analytics">
    <!-- 4cards -->
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base" v-for="data in totaldata">
        <vx-card>
          <div class="minicard">
            <div class="minititle">
              {{ data.title }}
            </div>
            <div class="flex down">
              <div class="count">{{ data.title == "Total Revenues" ? "€ " : "" }}{{ changevalue(data.count) }}</div>
              <div v-if="data.percent > 0" class="highpercent">{{ data.percent }}%
                <feather-icon icon="ArrowUpIcon" svgClasses="h-5 w-5" />
              </div>
              <div v-else-if="data.percent == 0" class="normalpercent">{{ data.percent }}%</div>
              <div v-else class="lowpercent">{{ data.percent }}%
                <feather-icon icon="ArrowDownIcon" svgClasses="h-5 w-5" />
              </div>
            </div>
            <div>Compare to last year({{ thisyear - 1 }})</div>
          </div>
        </vx-card>
      </div>
    </div>

    <!-- 3cards -->
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/4 mb-base" v-for="(data, index) in pendingdata">
        <vx-card>
          <div class="flex">
            <div class="pendingtext">{{ data.title }}</div>
          </div>
          <!-- Chart -->
          <div >
            <!-- <vue-apex-charts type="radialBar" height="420" :options="chartOption[index]" :series="data.percent" /> -->
            <vue-apex-charts  type="pie" height="345" class="mt-10 mb-10"
              :options="analyticsData.customersPie.chartOptions" :series="data.data" />
          </div>
          <ul>
            <li v-for="(status, indexi) in statusdata" :key="status.title" class="flex mb-3 justify-between">
              <span class="flex items-center">
                <span class="inline-block h-4 w-4 rounded-full mr-2 bg-white border-3 border-solid"
                  :class="`border-${status.color}`"></span>
                <span class="font-semibold ">{{ status.title }}</span>
              </span>
              <div class="flex" v-if="indexi == 1">
                <span class="count2">{{ data.data[indexi] }}</span>
                <div v-if="data.price != -1" class="count2">(€{{ data.price }})</div>
                <div v-if="data.difference > 0" class="highpercent">{{ data.difference }}
                  <feather-icon icon="ArrowUpIcon" svgClasses="h-5 w-5" />
                </div>
                <div v-else-if="data.difference == 0" class="normalpercent">{{ data.difference }}</div>
                <div v-else class="lowpercent">{{ data.difference }}
                  <feather-icon icon="ArrowDownIcon" svgClasses="h-5 w-5" />
                </div>
              </div>
              <div v-else>
                <span class="count2">{{ data.data[indexi] }}</span>
              </div>
            </li>
          </ul>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-1/4 mb-base">
        <vx-card>
          <div class="flex">
            <div class="pendingtext">Monthly Target</div>
          </div>
          <!-- CARD ACTION -->

          <!--          <div v-if="supportTracker.analyticsData"> -->
          <div class="vx-row text-center">
            <!-- Chart -->
            <div class="vx-col w-full justify-center mx-auto lg:mt-0 md:mt-6 sm:mt-0 mt-6">
              <vue-apex-charts type="radialBar" height="500"
                :options="analyticsData.supportTrackerRadialBar.chartOptions" :series="targetdata" />
            </div>
          </div>

          <!-- Support Tracker Meta Data -->
          <center class="px-8 pb-4">
            <div class="gray fs-20 mb-5 mt-5">You need abit more effort to hit monthly target</div>
            <button class="buttonstyle fs-20">Learn More</button>
          </center>
          <!--          </div>-->
        </vx-card>
      </div>
    </div>

    <!-- Graphic -->
    <div class="vx-row">
      <div class="vx-col w-full md:w-3/4 mb-base">
        <vx-card title="Revenue">
          <template slot="actions">
            <!-- <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon> -->
            <div class="flex">
              <span class="h-4 w-4 rounded-full mr-2 ml-2 border-5 border-solid"
                style="border-color: #3666E2; border-width: 7px;"></span>
              <div>Users</div>
              <span class="h-4 w-4 rounded-full mr-2 ml-2 border-5 border-solid"
                style="border-color: #0EBB7C; border-width: 7px;"></span>
              <div>Selfies</div>
            </div>
          </template>
          <!-- <template slot="actions">
                        <feather-icon icon="SettingsIcon" svgClasses="w-6 h-6 text-grey"></feather-icon>
                    </template> -->
          <div slot="no-body" class="p-6 pb-0">
            <vue-apex-charts type="line" height="266" :options="revenueOption.revenueComparisonLine.chartOptions"
              :series="revenueComparisondata" />
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full md:w-1/4 lg:w-1/4 xl:w-1/4 mb-base">
        <statistics-card-line icon="UsersIcon" statistic="92.6k" statisticTitle="Subscribers Gained"
          :chartData="membersdata.series" :total="membersdata.data.total" :percent="membersdata.data.percent"
          type="area"></statistics-card-line>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
import VxTimeline from '@/components/timeline/VxTimeline'
import handlingError from '@/handlingError/handlingError.js';

import moduleUserManagement from "@/store/user-management/moduleUserManagement.js";

export default {
  data() {
    return {
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      customersData: {},
      productsOrder: {},
      salesRadar: {},
      revenueComparisonLine: {},
      revenueOption: {},


      monthday: [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
      monthname: ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],

      revenueComparisondata: [{
        data: [35, 26, 45, 12, 68, 56, 124],
        name: "Users"
      }, {
        data: [40, 50, 41, 31, 21, 31, 50],
        name: "Selfies"
      }
      ],

      targetdata: [87],

      membersdata: {
        data: {
          total: 17329,
          percent: 3.7,
        },
        series: [
          {
            data: [15, 63, 23, 53, 34, 43, 79, 42],
            name: "Active Members",
          }
        ]
      },

      totaldata: [{
        title: "Total Users",
        count: 14256,
        percent: 11.4,
      },
      {
        title: "Total Selfies",
        count: 643982,
        percent: 8.2,
      },
      {
        title: "Total Referrals",
        count: 18310,
        percent: -0.7,
      },
      {
        title: "Total Revenues",
        count: 54236,
        percent: 0.3,
      }],

      pendingdata: [{
        title: "Selfies",
        data: [13, 12, 15],
        price: 34.5,
        difference: 6
      }, {
        title: "Payments",
        data: [131, 122, 100],
        price: -1,
        difference: -97
      }, {
        title: "Identity",
        data: [133, 128, 135],
        price: -1,
        difference: 56
      }],

      chartOption: [],

      statusdata: [
        {
          title: "Approved",
          color: "success"
        },
        {
          title: "Pending",
          color: "primary"
        },
        {
          title: "Rejected",
          color: "danger"
        }
      ],
      temp1: 0,
      temp2: 0,
      temp3: 0,

      thisyear: 2024,

      analyticsData,
      dispatchedOrders: []
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline
  },
  beforeCreate() {
    if (!this.$store.state.auth.isUserLoggedIn()) this.$router.push('/login')
    //  User Reward Card
  },
  methods: {
    changevalue(value) {
      var str = "" + value % 1000
      value = (value - value % 1000) / 1000
      while (value) {
        str = value % 1000 + ',' + str
        value = (value - value % 1000) / 1000
      }
      return str
    }
  },
  created() {
    this.revenueOption = analyticsData;
    const date = new Date()
    var month = date.getMonth() + 1, day = date.getDate() - 6;
    var string = []
    for (var i = 0; i < 7; i++) {
      if (day < 1) {
        month--
        day += this.monthday[month]
      }
      else if (day > this.monthday[month]) {
        month++;
        day = 1;
      }
      string.push(this.monthname[month] + ' ' + day)
      day++;
    }
    this.revenueOption.revenueComparisonLine.chartOptions.xaxis.categories = string;

    // getDashboardData
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/getDashboardData', 'getUsersCount')
      .then((response) => {
        this.totaldata[0].count = response.data.count;
        this.totaldata[0].percent = response.data.percent.toFixed(2);
      }).catch(err => {
        handlingError.handleError(err);
      })

    this.$store.dispatch('userManagement/getDashboardData', 'getSelfiesCount')
      .then((response) => {
        this.totaldata[1].count = response.data.count;
        this.totaldata[1].percent = response.data.percent.toFixed(2);
      }).catch(err => {
        handlingError.handleError(err);
      })
    this.$store.dispatch('userManagement/getDashboardData', 'getReferralsCount')
      .then((response) => {
        this.totaldata[2].count = response.data.count;
        this.totaldata[2].percent = response.data.percent.toFixed(2);
      }).catch(err => {
        handlingError.handleError(err);
      })
    this.$store.dispatch('userManagement/getDashboardData', 'getRevenuesCount')
      .then((response) => {
        this.totaldata[3].count = response.data.count;
        this.totaldata[3].percent = response.data.percent.toFixed(2);
      }).catch(err => {
        handlingError.handleError(err);
      })

    this.$store.dispatch('userManagement/getDashboardData', 'getSelfiesData')
      .then((response) => {
        this.pendingdata[0].data = response.data.data;
        this.pendingdata[0].price = response.data.price;
        this.pendingdata[0].difference = response.data.difference;
      }).catch(err => {
        handlingError.handleError(err);
      })

    this.$store.dispatch('userManagement/getDashboardData', 'getPaymentData')
      .then((response) => {
        this.pendingdata[1].data = response.data.data;
        this.pendingdata[1].price = response.data.price;
        this.pendingdata[1].difference = response.data.difference;
      }).catch(err => {
        handlingError.handleError(err);
      })

    this.$store.dispatch('userManagement/getDashboardData', 'getIdentityData')
      .then((response) => {
        this.pendingdata[2].data = response.data.data;
        this.pendingdata[2].price = response.data.price;
        this.pendingdata[2].difference = response.data.difference;
      }).catch(err => {
        handlingError.handleError(err);
      })

    
    this.$store.dispatch('userManagement/getDashboardData', 'getRevenuesData')
      .then((response) => {
        this.revenueComparisondata[0].data = response.data.usercount;
        this.revenueComparisondata[1].data = response.data.selfiescount;
      }).catch(err => {
        handlingError.handleError(err);
      })

    this.$store.dispatch('userManagement/getDashboardData', 'getActiveMembers')
      .then((response) => {
        this.membersdata.data.total = response.data.count;
        this.membersdata.data.percent = response.data.percent;
        this.membersdata.series[0].data = response.data.userdata;
      }).catch(err => {
        handlingError.handleError(err);
      })

    this.$store.dispatch('userManagement/getDashboardData', 'getTargetPercent')
      .then((response) => {
        this.targetdata[0] = response.data.percent;
      }).catch(err => {
        handlingError.handleError(err);
      })

  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}

.minicard {
  width: 100%;
  height: 100px;
}

.minititle {
  font-size: 18px;
  color: black;
  margin-bottom: 12px;
  font-weight: bold;
}

.highpercent {
  color: lightgreen;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}

.normalpercent {
  color: orange;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}

.lowpercent {
  color: crimson;
  font-size: 18px;
  font-weight: bold;
  margin-left: 10px;
}

.count {
  font-size: 30px;
  color: black;
  font-weight: bold;
  margin-right: 20px
}

.down {
  align-items: center;
}

.pendingtext {
  font-size: 20px;
  font-weight: bold;
  color: black;
}

.count2 {
  font-size: 18px;
  color: black;
  font-weight: bold;
}

.buttonstyle {
  background-color: #3666E2;
  border-radius: 13px;
  width: 130px;
  height: 50px;
  border: none;
  color: white;
}

.fs-20 {
  font-size: 20px;
}

.gray {
  color: gray;
}

.p-10 {
  padding: 8px;
}

.m-10 {
  margin-top: 8px;
}

/*! rtl:end:ignore */
</style>
